import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';

export interface IMoreFlatsButtonProps {
  href: string;
}

export const MoreFlatsButton: React.FC<React.PropsWithChildren<IMoreFlatsButtonProps>> = ({ href }) => {
  return (
    <LinkButton theme="fill_secondary" href={href} fullWidth>
      Смотреть такие квартиры
    </LinkButton>
  );
};
